export default __webpack_public_path__ + "static/media/Sycamore Icons-02.432d16e3.svg";